"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthenticationApi = void 0;
const runtime = __importStar(require("../runtime"));
const models_1 = require("../models");
/**
 *
 */
class AuthenticationApi extends runtime.BaseAPI {
    /**
     * Authenticates the Cognito Token
     */
    async cognitoSsoRaw(requestParameters) {
        if (requestParameters.xCLEARCorrelationInfo === null || requestParameters.xCLEARCorrelationInfo === undefined) {
            throw new runtime.RequiredError('xCLEARCorrelationInfo', 'Required parameter requestParameters.xCLEARCorrelationInfo was null or undefined when calling cognitoSso.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters.xCLEARCorrelationInfo !== undefined && requestParameters.xCLEARCorrelationInfo !== null) {
            headerParameters['X-CLEAR-CorrelationInfo'] = String(requestParameters.xCLEARCorrelationInfo);
        }
        if (requestParameters.xAmznTraceId !== undefined && requestParameters.xAmznTraceId !== null) {
            headerParameters['X-Amzn-Trace-Id'] = String(requestParameters.xAmznTraceId);
        }
        const response = await this.request({
            path: `/public/authentication/cognito/sso`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: models_1.CognitoFormToJSON(requestParameters.cognitoForm),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.SessionTokenFromJSON(jsonValue));
    }
    /**
     * Authenticates the Cognito Token
     */
    async cognitoSso(requestParameters) {
        const response = await this.cognitoSsoRaw(requestParameters);
        return await response.value();
    }
    /**
     * Start the authentication process by collecting email and/or phone from a user
     */
    async initiateAuthRaw(requestParameters) {
        if (requestParameters.xCLEARCorrelationInfo === null || requestParameters.xCLEARCorrelationInfo === undefined) {
            throw new runtime.RequiredError('xCLEARCorrelationInfo', 'Required parameter requestParameters.xCLEARCorrelationInfo was null or undefined when calling initiateAuth.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters.xCLEARCorrelationInfo !== undefined && requestParameters.xCLEARCorrelationInfo !== null) {
            headerParameters['X-CLEAR-CorrelationInfo'] = String(requestParameters.xCLEARCorrelationInfo);
        }
        if (requestParameters.xAmznTraceId !== undefined && requestParameters.xAmznTraceId !== null) {
            headerParameters['X-Amzn-Trace-Id'] = String(requestParameters.xAmznTraceId);
        }
        const response = await this.request({
            path: `/public/authentication/initiate-auth`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: models_1.OtpFormToJSON(requestParameters.otpForm),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.OtpResponseFromJSON(jsonValue));
    }
    /**
     * Start the authentication process by collecting email and/or phone from a user
     */
    async initiateAuth(requestParameters) {
        const response = await this.initiateAuthRaw(requestParameters);
        return await response.value();
    }
    /**
     * Authenticates a user based on credentials
     */
    async loginRaw(requestParameters) {
        if (requestParameters.xCLEARCorrelationInfo === null || requestParameters.xCLEARCorrelationInfo === undefined) {
            throw new runtime.RequiredError('xCLEARCorrelationInfo', 'Required parameter requestParameters.xCLEARCorrelationInfo was null or undefined when calling login.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters.xCLEARCorrelationInfo !== undefined && requestParameters.xCLEARCorrelationInfo !== null) {
            headerParameters['X-CLEAR-CorrelationInfo'] = String(requestParameters.xCLEARCorrelationInfo);
        }
        if (requestParameters.xAmznTraceId !== undefined && requestParameters.xAmznTraceId !== null) {
            headerParameters['X-Amzn-Trace-Id'] = String(requestParameters.xAmznTraceId);
        }
        const response = await this.request({
            path: `/public/authentication/login`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: models_1.CredentialsFormToJSON(requestParameters.credentialsForm),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.SessionTokenFromJSON(jsonValue));
    }
    /**
     * Authenticates a user based on credentials
     */
    async login(requestParameters) {
        const response = await this.loginRaw(requestParameters);
        return await response.value();
    }
    /**
     * Logouts a Session TokenAuthenticates the SAML Assertion
     */
    async logoutRaw(requestParameters) {
        if (requestParameters.xCLEARCorrelationInfo === null || requestParameters.xCLEARCorrelationInfo === undefined) {
            throw new runtime.RequiredError('xCLEARCorrelationInfo', 'Required parameter requestParameters.xCLEARCorrelationInfo was null or undefined when calling logout.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (requestParameters.xCLEARCorrelationInfo !== undefined && requestParameters.xCLEARCorrelationInfo !== null) {
            headerParameters['X-CLEAR-CorrelationInfo'] = String(requestParameters.xCLEARCorrelationInfo);
        }
        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
            headerParameters['Authorization'] = String(requestParameters.authorization);
        }
        if (requestParameters.xAmznTraceId !== undefined && requestParameters.xAmznTraceId !== null) {
            headerParameters['X-Amzn-Trace-Id'] = String(requestParameters.xAmznTraceId);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/protected/authentication/logout`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Logouts a Session TokenAuthenticates the SAML Assertion
     */
    async logout(requestParameters) {
        await this.logoutRaw(requestParameters);
    }
    /**
     * Submit the OTP code to be checked against the one that was sent by the initiateAuth operation
     */
    async otpChallengeRaw(requestParameters) {
        if (requestParameters.xCLEARCorrelationInfo === null || requestParameters.xCLEARCorrelationInfo === undefined) {
            throw new runtime.RequiredError('xCLEARCorrelationInfo', 'Required parameter requestParameters.xCLEARCorrelationInfo was null or undefined when calling otpChallenge.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters.xCLEARCorrelationInfo !== undefined && requestParameters.xCLEARCorrelationInfo !== null) {
            headerParameters['X-CLEAR-CorrelationInfo'] = String(requestParameters.xCLEARCorrelationInfo);
        }
        if (requestParameters.xAmznTraceId !== undefined && requestParameters.xAmznTraceId !== null) {
            headerParameters['X-Amzn-Trace-Id'] = String(requestParameters.xAmznTraceId);
        }
        const response = await this.request({
            path: `/public/authentication/otp-challenge`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: models_1.OtpCodeToJSON(requestParameters.otpCode),
        });
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Submit the OTP code to be checked against the one that was sent by the initiateAuth operation
     */
    async otpChallenge(requestParameters) {
        await this.otpChallengeRaw(requestParameters);
    }
    /**
     * Starts the SAML SP-INIT (Service Provider Initialization) flow
     */
    async samlInitRaw(requestParameters) {
        if (requestParameters.xCLEARCorrelationInfo === null || requestParameters.xCLEARCorrelationInfo === undefined) {
            throw new runtime.RequiredError('xCLEARCorrelationInfo', 'Required parameter requestParameters.xCLEARCorrelationInfo was null or undefined when calling samlInit.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (requestParameters.xCLEARCorrelationInfo !== undefined && requestParameters.xCLEARCorrelationInfo !== null) {
            headerParameters['X-CLEAR-CorrelationInfo'] = String(requestParameters.xCLEARCorrelationInfo);
        }
        if (requestParameters.xAmznTraceId !== undefined && requestParameters.xAmznTraceId !== null) {
            headerParameters['X-Amzn-Trace-Id'] = String(requestParameters.xAmznTraceId);
        }
        const response = await this.request({
            path: `/public/authentication/saml/init`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.TextApiResponse(response);
    }
    /**
     * Starts the SAML SP-INIT (Service Provider Initialization) flow
     */
    async samlInit(requestParameters) {
        const response = await this.samlInitRaw(requestParameters);
        return await response.value();
    }
    /**
     * Authenticates the SAML Response from the IDP
     */
    async samlSsoRaw(requestParameters) {
        if (requestParameters.xCLEARCorrelationInfo === null || requestParameters.xCLEARCorrelationInfo === undefined) {
            throw new runtime.RequiredError('xCLEARCorrelationInfo', 'Required parameter requestParameters.xCLEARCorrelationInfo was null or undefined when calling samlSso.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (requestParameters.xCLEARCorrelationInfo !== undefined && requestParameters.xCLEARCorrelationInfo !== null) {
            headerParameters['X-CLEAR-CorrelationInfo'] = String(requestParameters.xCLEARCorrelationInfo);
        }
        if (requestParameters.xAmznTraceId !== undefined && requestParameters.xAmznTraceId !== null) {
            headerParameters['X-Amzn-Trace-Id'] = String(requestParameters.xAmznTraceId);
        }
        const consumes = [
            { contentType: 'application/x-www-form-urlencoded' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);
        let formParams;
        let useForm = false;
        if (useForm) {
            formParams = new FormData();
        }
        else {
            formParams = new URLSearchParams();
        }
        if (requestParameters.sAMLResponse !== undefined) {
            formParams.append('SAMLResponse', requestParameters.sAMLResponse);
        }
        if (requestParameters.relayState !== undefined) {
            formParams.append('RelayState', requestParameters.relayState);
        }
        const response = await this.request({
            path: `/public/authentication/saml/sso`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.SessionTokenFromJSON(jsonValue));
    }
    /**
     * Authenticates the SAML Response from the IDP
     */
    async samlSso(requestParameters) {
        const response = await this.samlSsoRaw(requestParameters);
        return await response.value();
    }
    /**
     * Obtains high level summary information about a session
     */
    async sessionInfoRaw(requestParameters) {
        if (requestParameters.xCLEARCorrelationInfo === null || requestParameters.xCLEARCorrelationInfo === undefined) {
            throw new runtime.RequiredError('xCLEARCorrelationInfo', 'Required parameter requestParameters.xCLEARCorrelationInfo was null or undefined when calling sessionInfo.');
        }
        if (requestParameters.sessionToken === null || requestParameters.sessionToken === undefined) {
            throw new runtime.RequiredError('sessionToken', 'Required parameter requestParameters.sessionToken was null or undefined when calling sessionInfo.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters.xCLEARCorrelationInfo !== undefined && requestParameters.xCLEARCorrelationInfo !== null) {
            headerParameters['X-CLEAR-CorrelationInfo'] = String(requestParameters.xCLEARCorrelationInfo);
        }
        if (requestParameters.xAmznTraceId !== undefined && requestParameters.xAmznTraceId !== null) {
            headerParameters['X-Amzn-Trace-Id'] = String(requestParameters.xAmznTraceId);
        }
        const response = await this.request({
            path: `/public/authentication/session`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: models_1.SessionTokenToJSON(requestParameters.sessionToken),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.SessionSummaryFromJSON(jsonValue));
    }
    /**
     * Obtains high level summary information about a session
     */
    async sessionInfo(requestParameters) {
        const response = await this.sessionInfoRaw(requestParameters);
        return await response.value();
    }
    /**
     * Complete the authentication process by collecting biographics from a user and signing them in
     */
    async signInRaw(requestParameters) {
        if (requestParameters.xCLEARCorrelationInfo === null || requestParameters.xCLEARCorrelationInfo === undefined) {
            throw new runtime.RequiredError('xCLEARCorrelationInfo', 'Required parameter requestParameters.xCLEARCorrelationInfo was null or undefined when calling signIn.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters.xCLEARCorrelationInfo !== undefined && requestParameters.xCLEARCorrelationInfo !== null) {
            headerParameters['X-CLEAR-CorrelationInfo'] = String(requestParameters.xCLEARCorrelationInfo);
        }
        if (requestParameters.xAmznTraceId !== undefined && requestParameters.xAmznTraceId !== null) {
            headerParameters['X-Amzn-Trace-Id'] = String(requestParameters.xAmznTraceId);
        }
        const response = await this.request({
            path: `/public/authentication/sign-in`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: models_1.SignInRequestToJSON(requestParameters.signInRequest),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.SessionTokenFromJSON(jsonValue));
    }
    /**
     * Complete the authentication process by collecting biographics from a user and signing them in
     */
    async signIn(requestParameters) {
        const response = await this.signInRaw(requestParameters);
        return await response.value();
    }
}
exports.AuthenticationApi = AuthenticationApi;
//# sourceMappingURL=AuthenticationApi.js.map